import React, {memo} from 'react'
import {connect} from 'react-redux'
import cx from 'classnames'

/* Components */
import VariantPanel from './panel/VariantPanel'

/* Utils */
import {getCombinedVariantText} from '../../../../modules/variant/variantUtils'
import DataSet from '../../../../utils/DataSet'

/* Constants */
import {PRODUCT_INFORMATION_TEXT} from '../../../../modules/product/productDesktopConstants'

/* Styles */
import s from './variant.scss'

const Variant = memo((props) => {
  const {
    className,
    isAvailableProduct,
    isClosedProduct,
    isBundle,
    isInStock,
    activeVariant,
    isPreOrder,
    inStockDate,
    variants,
    pageTypeForDavinci,
    sku,
    price,
    productId,
    listingId,
    merchantId,
    categoryId,
    categoryName,
    merchantName
  } = props

  const getInformationContent = () => {
    let informationText = null

    if (isClosedProduct && !isInStock) {
      informationText = PRODUCT_INFORMATION_TEXT.IS_CLOSED_PRODUCT
    } else if (isBundle) {
      informationText = PRODUCT_INFORMATION_TEXT.IS_CAMPAIGN_PRODUCT
    } else if (isPreOrder && inStockDate) {
      informationText = {
        description: PRODUCT_INFORMATION_TEXT.IS_PRE_ORDER.description.replace('{date}', new Date(inStockDate).toLocaleString('tr-TR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })),
        subDescription: PRODUCT_INFORMATION_TEXT.IS_PRE_ORDER.subDescription,
      }
    } else if (!isInStock) {
      informationText = PRODUCT_INFORMATION_TEXT.IS_NO_STOCK
    } else if (!activeVariant?.hasCombination) {
      informationText = {
        description: `${getCombinedVariantText(activeVariant)} ${PRODUCT_INFORMATION_TEXT.IS_NO_COMBINATION}`,
      }
    }

    if (isAvailableProduct && !(isPreOrder && inStockDate)) {
      return null
    }

    return (
      <div className={cx(s.informationContent, {[s.flexStart]: informationText?.subDescription})}>
        <i className={s.icon}/>
        <div className={s.textContent}>
          <span className={s.description}>
            {informationText?.description}
          </span>
          {
            informationText?.subDescription &&
            <span className={s.subDescription}>{informationText?.subDescription}</span>
          }
        </div>
      </div>
    )
  }

  const haveSelectedVariant = variants && Object.values(variants).some(variant =>
    variant?.properties?.some(property => property?.isSelected)
  )
  const hideVariantPanel = (isClosedProduct && !isInStock) || isBundle || !haveSelectedVariant

  return (
    <div
      className={cx(s.root, className)}
      data-hbus={DataSet.createComponentViewDataForDavinci({
        pageType: pageTypeForDavinci,
        pageValue: sku,
        placement: 'buybox',
        component: 'variant',
        componentDetail: 'variant',
        categoryHierarchy: `${categoryId} - ${categoryName}`,
        productId,
        listingId,
        merchantId,
        merchantName,
        price: `${price}`
      })}>
      {getInformationContent()}
      {
        !hideVariantPanel &&
        <VariantPanel {...props} />
      }
    </div>
  )
})

const mapStateToProps = (state) => {
  const {
    productState: {
      variants,
      activeVariant,
      unAvailableVariants,
      isAvailableProduct,
    },
  } = state

  return {
    variants,
    activeVariant,
    unAvailableVariants,
    isAvailableProduct,
  }
}

export default connect(mapStateToProps)(Variant)
